/**
 * Clear out the layout attributes from the table elements within the element passed.
 * Currently works only for width: 
 * Takes the width (if in percentage) of the attribute and translates it into a class which is then set on the table.
 * 
 * @param {element} node 
 */
export function clearTableLayout(node) {
	const tablesWithWidth = [...node.querySelectorAll('table[width]')];
	if (tablesWithWidth && tablesWithWidth.length > 0) {
		tablesWithWidth.forEach(table => {
			const defWidth = table.getAttribute('width');
			if (defWidth && defWidth.endsWith('%')) {
				table.classList.add(`c-table__width--${defWidth.slice(0, -1)}`)
			} else {
				table.classList.add(`c-table__width--auto`);
			}
			table.removeAttribute('width');
		})
	}
}